/* global HOME_URL, HOME_TITLE */

import { startLoading } from '../../apps/components/Notifications'

export default {
  name: 'Error403',
  template: `
<div class="header-hybrid-padding">
  <div class="container grid section-margin-bottom section-margin-small-top">
    <div class="col-12 col-sm-10 col-md-8 col-xl-6 offset-xl-2 col-xxl-5 page-error">
      <p class="large-text">{{ $t('error403.text') }}</p>

      <div class="button-group">
        <button
          @click="e => {startLoading('authStatus'); $AuthService.signIn()}"
          class="button button--primary">
          {{ $t('authStatus.login') }}
        </button>
        <a :href="HOME_URL" :title="HOME_TITLE" class="button button--outline">
          {{ $t('error403.goHome') }}
        </a>
      </div>
    </div>
  </div>
</div>
  `,
  props: { title: String, content: String },
  setup () {
    return { startLoading, HOME_TITLE, HOME_URL }
  },
}
